import { render, staticRenderFns } from "./AddTutorData.vue?vue&type=template&id=4ace8b39&scoped=true"
import script from "./AddTutorData.vue?vue&type=script&lang=js"
export * from "./AddTutorData.vue?vue&type=script&lang=js"
import style0 from "./AddTutorData.vue?vue&type=style&index=0&id=4ace8b39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace8b39",
  null
  
)

export default component.exports